import { TableDataType } from '@spo/logic';
import { Cell, flexRender, Row } from '@tanstack/react-table';
import './tableView.scss';

type TableViewRowProps<T extends TableDataType> = {
  row: Row<T>;
  onCellClick?: (row: T) => void;
};
export const TableViewRow = <T extends TableDataType>({
  row,
  onCellClick,
}: TableViewRowProps<T>) => {
  return (
    <tr key={row.id} data-testid="table-view-row">
      {row.getVisibleCells().map((cell: Cell<T, unknown>) => (
        <td
          key={cell.id}
          role="gridcell"
          onClick={() => onCellClick?.(row?.original)}
          onKeyDown={() => onCellClick?.(row?.original)}
        >
          {flexRender(cell.column.columnDef.cell, cell.getContext())}
        </td>
      ))}
    </tr>
  );
};
